import Num from '@flipster/utils/num';

import { OrderStatusEnum, OrderTypeEnum } from '../../types';
import { TransOrderCancelReason, TransOrderStatus } from '../order/trans';
import { FillHistory, OrderHistory } from './types';

const calcOrderFillValue = (price: string, qty: string): string | undefined => {
  if (qty === '') return undefined;
  if (price === '') return '0';
  const numPrice = Num(price);
  const numQty = Num(qty);
  if (numPrice.isZero() || numQty.isZero()) return '0';
  return numPrice.multipliedBy(numQty).toString();
};

export const fillHistoryInstance = (h: FillHistory) => {
  const isLiquidation = h.orderType === OrderTypeEnum.Liquidation;

  return {
    ...h,
    isMarket: h.orderType === OrderTypeEnum.Market || h.orderType === OrderTypeEnum.StopMarket,
    execFee: isLiquidation ? undefined : h.execFee,
    fillValue: calcOrderFillValue(h.lastPrice, h.lastQty), // lastPrice * lastQty
  };
};

export type FillHistoryInstanceType = ReturnType<typeof fillHistoryInstance>;

export const orderHistoryInstance = (h: OrderHistory) => {
  const isCanceled = h.orderStatus === OrderStatusEnum.Canceled;
  const isConditionOrder = !!h.triggerSymbol;

  let transOrderStatus: string = TransOrderStatus[h.orderStatus];
  if (isCanceled && Num(h.cumQty).isGreaterThan(0))
    transOrderStatus = TransOrderStatus[OrderStatusEnum.PartiallyFilled];
  if (!isCanceled && isConditionOrder && !h.triggered) transOrderStatus = 'Untriggered';
  const transOrderCancelReason: string | undefined = TransOrderCancelReason[h.orderCancelReason];
  if (transOrderCancelReason) transOrderStatus += ` (${transOrderCancelReason})`;

  let { orderQty } = h;
  // TP, SL 의 경우 orderAmount 가 null 로 옴

  if (isCanceled && h.orderType === OrderTypeEnum.StopMarket && !!h.orderAmount) {
    // time trigger order인 경우 triggerPrice 가 없음
    if (!h.triggerPrice) {
      orderQty = '0';
    } else {
      orderQty = Num(h.orderAmount)
        .multipliedBy(h.initLeverage || '1') // spot인 경우에는 initLeverage 가 null 이므로 1로 처리
        .dividedBy(h.triggerPrice)
        .toString();
    }
  }

  return {
    ...h,
    isMarket: h.orderType === OrderTypeEnum.Market || h.orderType === OrderTypeEnum.StopMarket,
    isOpenOrder: h.orderStatus === OrderStatusEnum.New,
    fillValue: calcOrderFillValue(h.avgPrice, h.cumQty), // avgPrice * cumQty
    orderQty,
    transOrderStatus,
  };
};

export type OrderHistoryInstanceType = ReturnType<typeof orderHistoryInstance>;
